var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52224 6.87352H2.68446C1.93901 6.87352 1.33334 6.26785 1.33334 5.5224V2.68885C1.33334 1.93917 1.93901 1.3335 2.68446 1.3335H5.518C6.26345 1.3335 6.86912 1.93917 6.86912 2.68462V5.51816C6.87336 6.26785 6.26768 6.87352 5.52224 6.87352Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52224 6.87352H2.68446C1.93901 6.87352 1.33334 6.26785 1.33334 5.5224V2.68885C1.33334 1.93917 1.93901 1.3335 2.68446 1.3335H5.518C6.26345 1.3335 6.86912 1.93917 6.86912 2.68462V5.51816C6.87336 6.26785 6.26768 6.87352 5.52224 6.87352Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5358 6.87352H10.7022C9.9568 6.87352 9.35112 6.26785 9.35112 5.5224V2.68462C9.35112 1.93917 9.9568 1.3335 10.7022 1.3335H13.5358C14.2812 1.3335 14.8869 1.93917 14.8869 2.68462V5.51816C14.8869 6.26785 14.2812 6.87352 13.5358 6.87352Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52224 14.6665H2.68446C1.93901 14.6665 1.33334 14.0608 1.33334 13.3111V10.4776C1.33334 9.73214 1.93901 9.12646 2.68446 9.12646H5.518C6.26345 9.12646 6.86912 9.73214 6.86912 10.4776V13.3111C6.87336 14.0608 6.26768 14.6665 5.52224 14.6665Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5358 14.6666H10.7022C9.9568 14.6666 9.35112 14.061 9.35112 13.3155V10.482C9.35112 9.73654 9.9568 9.13086 10.7022 9.13086H13.5358C14.2812 9.13086 14.8869 9.73654 14.8869 10.482V13.3155C14.8869 14.061 14.2812 14.6666 13.5358 14.6666Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52224 6.87352H2.68446C1.93901 6.87352 1.33334 6.26785 1.33334 5.5224V2.68885C1.33334 1.93917 1.93901 1.3335 2.68446 1.3335H5.518C6.26345 1.3335 6.86912 1.93917 6.86912 2.68462V5.51816C6.87336 6.26785 6.26768 6.87352 5.52224 6.87352Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExternal);
export default __webpack_public_path__ + "static/media/icn-external.1dce8167.svg";
export { ForwardRef as ReactComponent };